import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Globals } from '../global/globals';
import { ProjectState } from '../dtos/project-state';
import { ScreeningAgreementOfficial, ScreeningAgreementPreview } from '../dtos/screening-agreement';

@Injectable({
  providedIn: 'root',
})
export class ScreeningAgreementService {
  constructor(
    private httpClient: HttpClient,
    private globals: Globals,
  ) {}

  getPreview(projectId: string, stage: ProjectState): Observable<ScreeningAgreementPreview> {
    return this.httpClient.get<ScreeningAgreementPreview>(this.uri(projectId, stage, 'preview'));
  }

  getOfficial(projectId: string, stage: ProjectState): Observable<ScreeningAgreementOfficial> {
    return this.httpClient.get<ScreeningAgreementOfficial>(this.uri(projectId, stage, 'official'));
  }

  private uri(projectId: string, stage: ProjectState, kind: 'preview' | 'official'): string {
    return `${this.globals.backendUri}/projects/${projectId}/stages/${stage}/agreement/${kind}`;
  }
}
